// @ts-nocheck
import React, { useState } from "react";
import { Box, Typography, Popover } from "@mui/material";
import CustomTextField from "../../../commonComponents/TextFieldComponent";
import { useSelector } from "react-redux";
import CustomSelectField from "../../../commonComponents/CommonSelect";
import CommonDatePicker from '../../../commonComponents/CommonDatePicker'
import { formatPhone, ssNumber } from "../../../../utils/formatUtils";
import dayjs from "dayjs";
import Info from "../../../../assets/info.png";

function IndividualForm({ values, errors, touched, handleChange, handleDateChange, handlePaste }) {
  const { states } = useSelector((state) => state.stateCounty);
  const stateOptions = states;
  const country = [{ value: "US", label: "US" }];
  const types = [
    { value: "id_passport", label: "Passport" },
    { value: "id_passport_card", label: "Passport Card" },
    { value: "doc_green_card", label: "Green Card" },
    { value: "id_drivers_license", label: "Driver's License" },
    { value: "id_drivers_permit", label: "Driver's Permit" },
    { value: "id_state", label: "State ID" }
  ];

  const countryDocumentTypes = ["id_passport", "id_passport_card", "doc_green_card"];
  const stateDocumentTypes = ["id_drivers_license", "id_drivers_permit", "id_state"];

  const [state, setState] = useState({
    open: false,
    type: "",
    anchorEl: null,
  });

  const { open, type, anchorEl } = state;

  const handleOpen = (event, open, type) => {
    setState({ open, type, anchorEl: event.currentTarget });
  };
  const handleClose = () => {
    setState((prev) => ({
      ...prev,
      open: false,
      anchorEl: null,
    }));
  };

  return (
    <>
    <Typography
        variant="h6"
        fontSize={16}
        fontWeight={400}
        mb={1}
        data-testid="personal-info-title"
      >
        Enter Personal Information
      </Typography>
      <Box
        // height={{ md: "15rem", sm: "100%" }}
        pr={1}
      >
        <Typography
          fontSize={14}
          fontStyle="italic"
          fontWeight={400}
          color="#3B3B3B"
          mb={2}
          data-testid="legal-name-instruction"
        >
          Please provide your legal first & last name.
        </Typography>

        <div className="grid md:grid-cols-2 gap-3 md:gap-4">
          <CustomTextField
            label="First Name"
            name="firstName"
            value={values.firstName || ""}
            onChange={handleChange}
            error={touched.firstName && !!errors.firstName}
            helperText={touched.firstName && errors.firstName}
            data-testid="first-name-field"
          />
          <CustomTextField
            label="Last Name"
            name="lastName"
            value={values.lastName || ""}
            onChange={handleChange}
            error={touched.lastName && !!errors.lastName}
            helperText={touched.lastName && errors.lastName}
            data-testid="last-name-field"
          />
          <CustomTextField
            label="Social Security Number"
            name="socialSecurityNumber"
            value={ssNumber(values.socialSecurityNumber) || ""}
            onChange={handleChange}
            // onKeyDown={handleKeyDown}
            onPaste={handlePaste}
            error={touched.socialSecurityNumber && !!errors.socialSecurityNumber}
            helperText={touched.socialSecurityNumber && errors.socialSecurityNumber}
            data-testid="social-security-field"
          />

          <CommonDatePicker
            label="Date of Birth"
            name="dateOfBirth"
            touched={touched.dateOfBirth}
            disableFuture={true}
            value={values.dateOfBirth || ""}
            onChange={handleDateChange}
            error={!!errors.dateOfBirth}
            maxDate={dayjs().subtract(18, 'year').subtract(1, 'day')}
            helperText={errors.dateOfBirth}
            data-testid="date-of-birth-picker"
          />
          <CustomTextField
            label="Email"
            name="email"
            type="email"
            // disabled={true}
            // readOnly={true}
            value={values.email || ""}
            onChange={handleChange}
            error={touched.email && !!errors.email}
            helperText={touched.email && errors.email}
            data-testid="email-field"
          />
          <CustomTextField
            label="Phone"
            name="phone"
            type="tel"
            value={formatPhone(values.phone)}
            onChange={handleChange}
            // onKeyDown={handleKeyDown}
            onPaste={handlePaste}
            error={touched.phone && !!errors.phone}
            helperText={touched.phone && errors.phone}
            data-testid="phone-field"
          />
        </div>

        <CustomTextField
          label="Address Line 1"
          name="address"
          value={values.address || ""}
          onChange={handleChange}
          sx={{ mt: 2 }}
          error={touched.address && !!errors.address}
          helperText={touched.address && errors.address}
          data-testid="address-line1-field"
        />
        <Box sx={{ textAlign: "end", fontWeight: 300, mb: 1, mt: "4px", fontSize: 11, color: "#9FA4AB" }} data-testid="address-line1-max-chars">
          {values.address.length || 0}/40
        </Box>
        <CustomTextField
          label={
            <Box display={"flex"}>
              Address Line 2
              <Typography sx={{
                fontSize: '0.75rem',
                fontStyle: 'italic',
                color: '#9FA4AB',
                ml: 1,
                alignSelf: 'flex-end',  // Aligns the text at the bottom
                marginY: 'auto'       // Pushes it to the bottom of the container
              }}>(Optional)</Typography>
            </Box>
          }
          name="addressLine2"
          value={values.addressLine2 || ""}
          onChange={handleChange}
          sx={{}}
          error={touched.addressLine2 && !!errors.addressLine2}
          helperText={touched.addressLine2 && errors.addressLine2}
          data-testid="address-line2-field"
        />
        <Box sx={{ textAlign: "end", fontWeight: 300, mb: 1, mt: "4px", fontSize: 11, color: "#9FA4AB" }} data-testid="address-line2-max-chars">
          {values.addressLine2?.length || 0}/40
        </Box>

        <div className="grid md:grid-cols-3 gap-3 md:gap-4">
          <Box>
            <CustomTextField
              label="City"
              name="city"
              value={values.city || ""}
              onChange={handleChange}
              // onKeyDown={handleKeyDown}
              onPaste={handlePaste}
              error={touched.city && !!errors.city}
              helperText={touched.city && errors.city}
              data-testid="city-field"
            />
            <Box sx={{ textAlign: "end", fontWeight: 300, mb: 1, mt: "6px", fontSize: 11, color: "#9FA4AB" }} data-testid="city-max-chars">
              {values.city.length || 0}/40
            </Box>
          </Box>

          <CustomSelectField
            label="State"
            name={"state"}
            size={"small"}
            options={states}
            value={values.state}
            onChange={handleChange}
            error={touched.state && !!errors.state}
            helperText={touched.state && errors.state}
            data-testid="state-field"
          />

          <CustomTextField
            label="Zip Code"
            name="ZipCode"
            value={values.ZipCode || ""}
            onChange={handleChange}
            // onKeyDown={handleKeyDown}
            onPaste={handlePaste}
            error={touched.ZipCode && !!errors.ZipCode}
            helperText={touched.ZipCode && errors.ZipCode}
            data-testid="zip-code-field"
            sx={{mb:3}}
          />
        </div>

        {/* Document Information Section */}
        <div className="grid md:grid-cols-2 mb-3 gap-3 md:gap-4">
          <CustomSelectField
            label="Govt / State issued ID"
            name="documentType"
            options={types}
            value={values.documentType}
            onChange={handleChange}
            error={touched.documentType && !!errors.documentType}
            helperText={touched.documentType && errors.documentType}
            data-testid="document-type-field"
          />
          <CustomTextField
            label="Document ID"
            disabled={!values.documentType}
            name="documentId"
            value={values.documentId}
            onChange={handleChange}
            error={touched.documentId && !!errors.documentId}
            helperText={touched.documentId && errors.documentId}
            data-testid="document-id-field"
          />
          {countryDocumentTypes.includes(values.documentType) && (
            <CustomSelectField
              label="Document Country"
              name="documentCountry"
              options={country}
              value={values.documentCountry}
              onChange={handleChange}
              error={touched.documentCountry && !!errors.documentCountry}
              helperText={touched.documentCountry && errors.documentCountry}
              data-testid="document-country-field"
            />
          )}
          {stateDocumentTypes.includes(values.documentType) && (
            <CustomSelectField
              label="Document State"
              name="documentState"
              options={stateOptions}
              value={values.documentState}
              onChange={handleChange}
              error={touched.documentState && !!errors.documentState}
              helperText={touched.documentState && errors.documentState}
              data-testid="document-state-field"
            />
          )}
        </div>
      </Box>
    </>
  );
}

export default IndividualForm;
